export const SeoFilterModule = angular
    .module('app.filters.seoFilter', [])
    .filter('seoFilter', () => {
        return (s) => {
            s = (s === undefined || s === null) ? '' : s;
            var str = s.toString().replace(/(\s)/g, '-').trim();
            str = str.replace(/([^a-zA-Z0-9-])+/g, '');
            return str.toLowerCase();
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/seo.filter.js